import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer } from "react-toastify";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import { IMAGE_URL } from "../../constants";
import { thirdparty } from "../..";
import Modal from "./DeleteConfirmModalPopup";
import Pagination from "react-js-pagination";
const board = () => {
  const [fatchdata, setFatchdata] = useState([]);
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState(false);
  const [id, setId] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8; // Number of items to display per page
  const [filteredData, setfilteredData] = useState("");

  const openModalDeleteConfirm = (id) => {
    setModalDeleteConfirm(true);
    setId(id);
  };

  const closeModalDeleteConfirm = () => {
    setModalDeleteConfirm(false);
  };

  console.log(fatchdata, "Dataset");

  useEffect(() => {
    fetchData(); // Initial data fetch
  }, []);

  const fetchData = async () => {
    try {
      const response = await thirdparty.get("/boardmembers"); // Update the API endpoint

      if (response.status === 200) {
        setFatchdata(response.data);
        // setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  //   const openModalDeleteConfirm = (itemId) => {
  //     setSelectedItemId(itemId);
  //     // Open the delete confirmation modal or perform other actions as needed
  //   };

  //   const closeModalDeleteConfirm = () => {
  //     setSelectedItemId(null);
  //     // Close the delete confirmation modal or perform other actions as needed
  //   };

  const handleDelete = async () => {
    try {
      const response = await thirdparty.delete(`/boardmembers/${id}`); // Update the API endpoint

      if (response.status === 200) {
        console.log(`Item with ID ${id} deleted successfully.`);
        fetchData(); // Fetch updated data after deletion
      }
    } catch (error) {
      console.error(`Error deleting item with ID ${id}:`, error.message);
    } finally {
      closeModalDeleteConfirm();
    }
  };

  useEffect(() => {
    const filteredData =
      fatchdata &&
      fatchdata.filter((item) =>
        item["name"].toLowerCase().includes(searchTerm.toLowerCase())
      );

    setfilteredData(filteredData);
  }, [fatchdata, searchTerm]);
  // Get current items to display
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData
    ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
    : [];

  // Handle search term change
  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="row page-content-wrapper g-0 g-3">
              <div className="col-sm-7"></div>
              <div className="col-sm-3 text-right"></div>
              <div className="col-sm-12 mb-4  d-flex justify-content-between align-items-center ">
                <h5 className="w-50">Board Members</h5>
                <div className="d-flex justify-content-between w-50">
                  <input
                    className="form-control"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    value={searchTerm}
                    onChange={handleSearch}
                    style={{ background: "transparent", border: "none" }}
                  />
                  <a
                    href="/addboardmember"
                    className="btn btn-sm waves-effect waves-light w-50"
                  >
                    Add Board Members
                  </a>
                </div>
              </div>
              {currentItems.length > 0 ? (
                currentItems.map((item) => (
                  <div className="col-md-3" key={item.id}>
                    <div className="card">
                      <img
                        className="card-img-top "
                        src={IMAGE_URL + "/BoardMember/" + item.image}
                        alt="Card image cap"
                        style={{ height: "100vh", maxHeight: "300px" }}
                      />
                      <div className="card-body">
                        <p>Serial No: {item.serial_order}</p>
                        <p>
                          Member type:{" "}
                          {item.type
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (char) => char.toUpperCase())}
                        </p>
                        <h5 className="card-title">{item.name}</h5>
                        <p className="card-text">{item.designation}</p>
                        <p className="card-text">{item.company}</p>
                        <h5
                          className="mt-2"
                          style={{
                            display: "flex",
                            alignItems: "flex-end",
                            columnGap: "10px",
                            rowGap: "10px",
                            justifyContent: "flex-end",
                          }}
                        >
                          <a
                            href={"/editboardmember/" + item.id}
                            baord_member_id={item.id}
                          >
                            <i className="fa fa-pencil-square "></i>
                          </a>
                          <a
                          // href={
                          //     "/viewpublication/" +
                          //     publication.id
                          // }
                          >
                            {/* <i className="fa fa-eye"></i> */}
                          </a>
                          <a onClick={() => openModalDeleteConfirm(item.id)}>
                            <i className="fa fa-trash"></i>
                          </a>
                        </h5>
                      </div>
                    </div>
                    <div>
                      <Modal
                        show={modalDeleteConfirm}
                        handleClose={closeModalDeleteConfirm}
                      >
                        <div className="custom_reviews_popup">
                          <h2 className="text-center">
                            Are you sure you want to delete this publication?
                          </h2>
                          <form className="pop-form" id="edit_education">
                            <div className="form-group row">
                              <div className="col-sm-3 text-center"></div>
                              <div className="col-sm-6 text-center">
                                <button
                                  type="button"
                                  className="blue_btn_box add_staff_btn mt-5 mr-2"
                                  onClick={closeModalDeleteConfirm}
                                >
                                  No
                                </button>
                                <button
                                  type="button"
                                  className="blue_btn_box add_staff_btn mt-5"
                                  onClick={() => {
                                    // Add your logic for handling delete here
                                    // e.g., this.modalDeletePublication(this.state.publications_id)
                                    console.log("Deleting...");
                                    // ModalDeleteConfirm(item.id);
                                    handleDelete();
                                  }}
                                >
                                  Yes
                                </button>
                              </div>
                              <div className="col-sm-3 text-center"></div>
                            </div>
                          </form>
                        </div>
                      </Modal>
                    </div>
                  </div>
                ))
              ) : (
                <div>No data found</div>
              )}
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={itemsPerPage}
                totalItemsCount={filteredData ? filteredData.length : 1}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default board;



// WEBPACK FOOTER //
// ./src/component/admin/board.js